export default __webpack_public_path__ + "images/onboarding/laddoo-b791fa0981833c63911b91161dea1bb8.svg";